import gql from 'graphql-tag';

const networkPlusOfferAcceptMutation = gql`
  mutation acceptNetworkPlusOffer($id: ID!) {
    acceptNetworkPlusOffer(input: { id: $id }) {
      success
      errors
    }
  }
`;

export default networkPlusOfferAcceptMutation;
